<template>
  <v-fade-transition>
    <div v-show="show" class="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      Caricamento...
    </div>
  </v-fade-transition>
</template>

<script>
export default {
  name: 'overlay',
  data() {
    return {
      show: false,
    };
  },
};
</script>
